import React, { useState } from "react";
import { Case, If, OtherWise } from "~/common/components/If";
import TabMenu from "~/common/components/TabMenu";
import Desc from "./components/Desc";
import Screenshot from "./components/Screenshot";
import Update from "./components/Update";
import { getTitle } from "~/utils/getTitle";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const PluginDetailModal = ({ selectedPlugin }) => {
	const { t } = useTranslation();
	const [currentTab, setCurrentTab] = useState("desc");
	const tabMenuList = [
		{ id: "desc", title: t("pages.myPage.PluginPage.desc") },
		{ id: "screenshot", title: t("pages.myPage.PluginPage.PluginDetailModal.screenshot") },
		{ id: "update", title: t("pages.myPage.PluginPage.PluginDetailModal.update") },
	];

	return (
		<>
			<Helmet>
				<title>{getTitle(`플러그인/${selectedPlugin.name}`)}</title>
			</Helmet>
			<div className="plugin-banner">
				<img src={selectedPlugin.bannerImg} alt={selectedPlugin.name} />
			</div>
			<div className="detail-container">
				<div className="tab-section">
					<TabMenu
						tabItem={tabMenuList}
						currentTab={currentTab}
						setCurrentTab={setCurrentTab}
					/>
					<If condition={currentTab} {...{ selectedPlugin }}>
						<Case condition={"desc"}>
							<Desc />
						</Case>
						<Case condition={"screenshot"}>
							<Screenshot />
						</Case>
						<OtherWise>
							<Update />
						</OtherWise>
					</If>
				</div>
				<div className="summary-section">
					<div className="img-wrap">
						<img src={selectedPlugin.thumbImg} alt={selectedPlugin.name} />
					</div>
					<p className="plugin-status">{t("pages.myPage.PluginPage.usage")}</p>
					<dl className="plugin-summary">
						<div>
							<dt>
								{t("pages.myPage.PluginPage.PluginDetailModal.plugin-summary.dt1")}{" "}
							</dt>
							<dd>{selectedPlugin.version}</dd>
						</div>
						<div>
							<dt>
								{t("pages.myPage.PluginPage.PluginDetailModal.plugin-summary.dt2")}{" "}
							</dt>
							<dd>
								{selectedPlugin.license === "free"
									? t(
											"pages.myPage.PluginPage.PluginDetailModal.plugin-summary.userAll"
									  )
									: ""}
							</dd>
						</div>
						<div>
							<dt>
								{t("pages.myPage.PluginPage.PluginDetailModal.plugin-summary.dt3")}{" "}
							</dt>
							<dd>
								{selectedPlugin.license === "free"
									? t("pages.myPage.PluginPage.price-free")
									: t("pages.myPage.PluginPage.price")}
							</dd>
						</div>
						<div>
							<dt>
								{t("pages.myPage.PluginPage.PluginDetailModal.plugin-summary.dt4")}{" "}
							</dt>
							<dd className="active">
								{t(
									"pages.myPage.PluginPage.PluginDetailModal.plugin-summary.active"
								)}{" "}
								(active)
							</dd>
						</div>
					</dl>
				</div>
			</div>
		</>
	);
};

export default PluginDetailModal;
